var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginContentBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_6508)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12_6508)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_6508",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -354,
    y: -138,
    width: 4153,
    height: 2072
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3798.2 -137.889H-353.994V1933.42H3798.2V-137.889Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3798.2 -137.889H-353.994V1933.42H3798.2V-137.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3798.2 -137.889H-353.994V1933.42H3798.2V-137.889Z",
    fill: "#283075"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.682
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1670.74 2863.48C1311.91 2552.2 1273.45 2008.95 1584.71 1650.11C1895.98 1291.27 2439.2 1252.82 2798.04 1564.1C3156.87 1875.39 3195.33 2418.63 2884.06 2777.48C2734.39 2949.92 2522.17 3055.94 2294.39 3071.75C2067.21 3087.87 1842.93 3012.95 1670.74 2863.48ZM3547.2 704.773C2713.02 -21.9313 1447.75 65.3654 721.092 899.564C-5.56828 1733.76 81.7467 2999.08 915.924 3725.79C1750.1 4452.49 3015.37 4365.19 3742.03 3531C4091.36 3129.88 4266.99 2606.24 4229.77 2075.68C4193.09 1546.26 3947.65 1053.11 3547.2 704.773Z",
    fill: "#1F2762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9546.91 7815.32C9309.18 7608.44 8948.67 7633.53 8741.8 7871.27C8741.69 7871.39 8741.58 7871.52 8741.48 7871.64C8430.16 8229.78 7887.37 8267.74 7529.24 7956.4C7171.11 7645.07 7133.15 7102.26 7444.46 6744.12L8008.19 6095.59L8760.39 6749.5C8998.36 6956.37 9358.97 6931.15 9565.83 6693.18C9772.69 6455.21 9747.47 6094.58 9509.5 5887.71L8757.3 5233.81L9303.67 4605.25C9510.03 4366.84 9484 4006.39 9245.6 3800.02C9007.95 3594.3 8648.61 3619.31 8442.03 3856.2L6582.82 5995.07C6270.88 6352.67 5728.03 6389.69 5370.33 6077.86C5013.49 5766.55 4975.64 5225.37 5285.68 4867.44L6223.96 3788.02C6430.7 3549.94 6405.13 3189.45 6167.06 2982.71C5929.24 2776.18 5569.09 2801.36 5362.32 3038.98L4424.04 4118.39C3698.92 4951.08 3786.07 6214.06 4618.96 6939.22C5026.06 7293.77 5559.23 7468.51 6096.99 7424C6159.92 8526.59 7104.64 9369.33 8207.06 9306.31C8745.78 9275.56 9249.44 9028.32 9603.12 8620.69C9809.97 8382.71 9784.77 8022.32 9546.91 7815.32Z",
    fill: "#1F2762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.462 654.899C1223.18 -151.556 1595.79 -588.525 2301.14 -1402.25C2544.01 -1681.65 2531.33 -2037.3 2277.61 -2258.3C2025.29 -2477.64 1670.62 -2437.84 1428.26 -2159.53C1122.8 -1808.13 1149.05 -1835.05 826.798 -1462.31C784.256 -1539.38 756.212 -1591.81 726.818 -1643.43C218.683 -2532.76 -875.71 -2899.62 -1817.08 -2496.13C-2755.07 -2099.56 -3244.13 -1060.34 -2951.82 -84.7839C-2723.7 666.717 -2216.7 1146.03 -1452.08 1312.09C-679.479 1480.05 -14.0594 1246.58 509.462 654.899ZM-1884.86 -609.567C-1894.22 -1078.67 -1535.29 -1473.19 -1067.43 -1508.36C-590.659 -1525.06 -189.465 -1154.38 -168.208 -677.793C-153.255 -207.562 -520.151 187.05 -990.302 206.21C-1460.37 221.498 -1857.09 -140.466 -1884.66 -610.05",
    fill: "#1F2762"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_6508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12_6508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 2047,
    fill: "white",
    transform: "translate(0 -124)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginContentBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-content-background.d6dcf2a17392c505808563356efbe73c.svg";